import { render, staticRenderFns } from "./ReportedNotes.vue?vue&type=template&id=3a875e74&scoped=true&"
import script from "./ReportedNotes.vue?vue&type=script&lang=js&"
export * from "./ReportedNotes.vue?vue&type=script&lang=js&"
import style0 from "./ReportedNotes.vue?vue&type=style&index=0&id=3a875e74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a875e74",
  null
  
)

export default component.exports